export default {
  LOAD_MENU_DATA: 'load_menu_data',
  UPDATE_KEEP_OPEN: 'update_keep_open',
  UPDATE_COLLAPSE_MENU: 'update_collapse_menu',
  UPDATE_COLLAPSE_SINGLE_MENU: 'update_collapse_single_menu',
  ACTIVE_LEFTMENU: 'active_leftmenu',
  LEFTMENU_SORTING: 'leftmenu_sorting',
  UPDATE_LEFTMENU_DATA: 'update_leftmenu_data',
  DELETE_LEFTMENU_DATA: 'delete_leftmenu_data',
  PIN_LEFTMENU_DATA: 'pin_leftmenu_data',
  UPDATE_MYWORK_COUNT: 'update_mywork_count',
  HIGHLIGHT_LEFTMENU_OBJECTID: 'highlight_leftmenu_objectid',
  UPDATE_KRS_COUNT: 'update_krs_count',
  SORTING_MENU_ITEM: 'SORTING_MENU_ITEM',
  UPDATE_WS_LEFT_MENU: 'UPDATE_WS_LEFT_MENU'
};
